//Based on https://github.com/john-doherty/swiped-events/blob/master/src/swiped-events.js

// need to defind a type to awoid typeScript error TS7005: Variable implicitly has an 'any[] | TouchList' type.
type ChangeTouches = TouchList | [];

interface SwipeState {
  xDown: number | null;
  xDiff: number;
  yDown?: number | null;
  yDiff: number;
  timeDown: number | null;
}

export const SwipeDirections = {
  SwipeDown: "SwipeDown",
  SwipeLeft: "SwipeLeft",
  SwipeRight: "SwipeRight",
  SwipeUp: "SwipeUp",
  NoSwipe: "NoSwipe",
};

export type SwipeDirection = (typeof SwipeDirections)[keyof typeof SwipeDirections];

export interface SwipeDetail {
  dir: SwipeDirection;
  xStart: number;
  xEnd: number;
  yStart: number;
  yEnd: number;
}

export const InitSwipeEvent = (currentEl: Element) => {
  const state: SwipeState = {
    xDiff: 0,
    xDown: null,
    yDown: null,
    yDiff: 0,
    timeDown: null,
  };

  const handleTouchStart = (e: TouchEvent) => {
    state.timeDown = Date.now();
    state.xDown = e.touches[0].clientX;
    state.yDown = e.touches[0].clientY;
    state.xDiff = 0;
    state.yDiff = 0;
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (state.xDown === null || state.yDown === null) return;

    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;

    state.xDiff = (state.xDown ?? 0) - xUp;
    state.yDiff = (state.yDown ?? 0) - yUp;
  };

  const handleTouchEnd = (e: TouchEvent) => {
    const swipeThreshold = 10;
    const swipeTimeout = 500;
    const timeDiff = Date.now() - (state.timeDown ?? 0);
    let eventType: SwipeDirection = SwipeDirections.NoSwipe;
    const changedTouches: ChangeTouches = e.changedTouches || e.touches || [];

    if (Math.abs(state.xDiff) > Math.abs(state.yDiff)) {
      // most significant
      if (Math.abs(state.xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
        if (state.xDiff > 0) {
          eventType = SwipeDirections.SwipeLeft;
        } else {
          eventType = SwipeDirections.SwipeRight;
        }
      }
    } else if (Math.abs(state.yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
      if (state.yDiff > 0) {
        eventType = SwipeDirections.SwipeUp;
      } else {
        eventType = SwipeDirections.SwipeDown;
      }
    }

    if (eventType !== SwipeDirections.NoSwipe) {
      const eventData: SwipeDetail = {
        dir: eventType,
        xStart: state.xDown ?? 0,
        xEnd: (changedTouches[0] || {}).clientX || -1,
        yStart: state.yDown ?? 0,
        yEnd: (changedTouches[0] || {}).clientY || -1,
      };

      // fire `swiped` event
      currentEl.dispatchEvent(new CustomEvent("swiped", { bubbles: true, cancelable: true, detail: eventData }));
    }

    // reset values
    state.xDown = null;
    state.yDown = null;
    state.timeDown = 0;
  };

  const removeSwipeEvents = (): void => {
    currentEl.removeEventListener("touchstart", handleTouchStart as EventListener);
    currentEl.removeEventListener("touchmove", handleTouchMove as EventListener);
    currentEl.removeEventListener("touchend", handleTouchEnd as EventListener);
  };

  currentEl.addEventListener("touchstart", handleTouchStart as EventListener, { passive: true });
  currentEl.addEventListener("touchmove", handleTouchMove as EventListener, { passive: true });
  currentEl.addEventListener("touchend", handleTouchEnd as EventListener, { passive: true });

  return removeSwipeEvents;
};
